export const TERMS_OF_USE_PATH = '/terms-of-use';
export const TERMS_AND_CONDITIONS_PATH = '/terms-and-conditions';

// ISO date, rendered per locale. Bump it whenever either document changes.
export const LEGAL_LAST_UPDATED = '2026-10-08';

export const LEGAL_CONTACT_EMAIL = 'legal@douboard.com';

export type LegalBlock = string | { list: string[] };

export type LegalSection = {
  id: string;
  title: string;
  blocks: LegalBlock[];
};

export type LegalDocument = {
  title: string;
  intro: string;
  sections: LegalSection[];
};
